export const groupConditionally = ( user_type, hasRole, menuGroup ) =>
{
    let group = undefined ;

    // If the group has a 'Don't group for this user type' rule, apply it first
    if ( menuGroup.ungroupedUserTypes !== undefined )
    {
        if ( !menuGroup.ungroupedUserTypes.includes ( user_type ))
        {
            group = menuGroup ;
        }
    }

    // If the group has a 'Group for this user ROLE' rule,
    // apply it if it hasn't already been grouped by one of the preceding rules
    if ( group === undefined )
    {
        if ( menuGroup.groupedUserRoles !== undefined )
        {
            if ( hasRole (menuGroup.groupedUserRoles))
            {
                group = menuGroup ;
            }
        }
    }

    return group ;
}

export const performGrouping = (validItems) =>
{
    let curUngroupedLabel = 'Root';
    let curUngroupedIndex = 1;

    const grouped = [{groupName: curUngroupedLabel + curUngroupedIndex, items: [], isGrouped: false}];

    // Partial investigation into grouping the menu items
    // Needs more work as it's currently bundling all the non-grouped items into one group at the beginning
    // which doesnt allow for more judicious mixed-order grouping
    const groups = validItems.reduce((accumulator, current, index) =>
    {
        const curActualLabel = curUngroupedLabel + curUngroupedIndex;

        const isUngroupedItem = current.group === undefined;
        const searchGroup = isUngroupedItem ? curActualLabel : current.group.name;

        const found = grouped.find((elem) =>
        {
            return elem.groupName === searchGroup;
        })

        if (found === undefined)
        {
            const newGroup = {groupName: searchGroup, icon: isUngroupedItem ? null : current.group.icon, items: [current], isGrouped: !isUngroupedItem};

            grouped.push(newGroup);

            if (!isUngroupedItem)
            {
                curUngroupedIndex++;
            }
        }
        else
        {
            found.items.push(current);
        }
    }, []);

    return grouped;
}

export const userMenuItems = (user_type, hasRole, items) =>
{
    return items.filter((item) =>
    {
        let allow = false;

        if (item.rolePermissionsOnly === true )
        {
            // New menu permissions are governed by permissions object only
            allow = item.enabled ;
        }
        else
        {
            if (item.userTypes !== undefined && allow === false)
            {
                allow = (item.userTypes.includes(user_type) && item.enabled === true);
            }

            if (item.userRoles !== undefined && allow === false)
            {
                allow = (hasRole(item.userRoles) && item.enabled === true);
            }
        }

        return allow;
    });
}